import React, { useContext, useReducer } from "react";
import { setLocalStorage } from "../helper/localStorage";

const loginContext = React.createContext();

const initialValue = {
  schoolData: {},
  studentData: {},
  gradeId: null,
  loader: false,
  multiDLogin: "",
  err: false,
  supportData: {},
};
const reducer = (state, action) => {
  switch (action.type) {
    case "SCHOOL_DATA": {
      setLocalStorage("show_result", action.payload.show_result);
      return {
        ...state,
        schoolData: action.payload,
        err: false,
        loader: false,
      };
    }
    case "STUDENT_DATA": {
      setLocalStorage("ud", action.payload);
      setLocalStorage("gradeId", action.payload.grade_id);
      return {
        ...state,
        grade_id: action.payload.grade_id,
        studentData: action.payload,
        err: false,
        loader: false,
      };
    }
    case "MULTI_LOGIN": {
      return {
        ...state,
        multiDLogin: action.payload,
        err: false,
        loader: false,
      };
    }
    case "LOGIN_ERR": {
      return { ...state, err: true, loader: false };
    }
    case "LOGIN_LOADER": {
      return { ...state, loader: true };
    }
    case "RESET_LOGIN_DATA": {
      return { ...initialValue };
    }
    case "SUPPORT_DATA": {
      return { ...state, loader: false, supportData: action.payload };
    }
    case "RESET_SUPPORT_DATA": {
      console.log("RESET_SUPPORT_DATA");
      return { ...state, supportData: {} };
    }
    case "SUPPORT_ERR": {
      return { ...state, loader: false };
    }
    default:
      return state;
  }
};

export function LoginProvider(props) {
  const [loginC, dispatchLogin] = useReducer(reducer, initialValue);
  return <loginContext.Provider value={{ loginC, dispatchLogin }} {...props} />;
}

export function LoginContext() {
  const context = useContext(loginContext);
  if (!context) {
    throw new Error(" Please use the context inside parent scope");
  }
  return context;
}
